import Parse from 'parse'
import ParseViewModel from '@/utils/parse-object-pojo'

export const Employer = Parse.Object.extend('Employer');

export const EmployerVM = ParseViewModel(Employer, [
    'name',
    'files',
    'images',
]);

export default {
    Employer,
    EmployerVM,
}



// WEBPACK FOOTER //
// ./src/models/employer.js